import React, { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter, DialogTrigger } from "@/components/ui/dialog";
import { Loader2, MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";

export default function ShareQuoteDialog({ pickup, dropoff, items, service, disabled, partner = false, triggerClassName = "", onShared }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    if (!phone.trim()) { toast.error("Enter their mobile number"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/quotes/share", {
        pickup, dropoff, service,
        items: items.map((i) => ({ size: i.size, quantity: i.quantity, weight_kg: parseFloat(i.weight) || 1 })),
        friend_name: name.trim(), friend_phone: phone.trim(),
      });
      toast.success(`Quote texted to ${data.to} — ${data.remaining_today} share${data.remaining_today === 1 ? "" : "s"} left today`);
      setOpen(false); setName(""); setPhone("");
      onShared?.();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Couldn't send the text"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" disabled={disabled} data-testid="share-quote-button"
          className={`gap-2 border-kilted-green text-kilted-green hover:bg-kilted-green/10 ${triggerClassName}`}>
          <MessageSquare className="h-4 w-4" /> {partner ? "Text quote to your customer" : "Text this quote to a friend"}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{partner ? "Text this quote to your customer" : "Text this quote to a friend"}</DialogTitle>
          <DialogDescription>They'll get an SMS with the price and a link to view and book it themselves (valid 7 days).</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5">
            <Label>{partner ? "Customer's name (optional)" : "Friend's name (optional)"}</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Morag" data-testid="share-quote-name" />
          </div>
          <div className="space-y-1.5">
            <Label>Their mobile</Label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="04xx xxx xxx" inputMode="tel" data-testid="share-quote-phone" />
          </div>
        </div>
        <DialogFooter>
          <Button onClick={send} disabled={busy} data-testid="share-quote-send"
            className="w-full gap-2 bg-kilted-green text-white hover:bg-kilted-greenLight sm:w-auto">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />} Send SMS
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
